<!--
 * @Author: zyf
 * @Date: 2025-05-29 14:58:14
 * @LastEditors: zyf
 * @LastEditTime: 2025-06-20 09:25:06
 * @Descripttion: 
-->
<!--
 * @Author: zyf
 * @Date: 2025-04-18 11:41:51
 * @LastEditors: zyf
 * @LastEditTime: 2025-06-03 10:51:54
 * @Descripttion: 
-->
<template>
  <el-dialog :visible.sync="showFlag" width="1280px" append-to-body :close-on-click-modal="false" :fullscreen="isFullScreen" class="custom-notice-message-center-dialog" :class="{'custom-notice-message-center-fullscreen': isFullScreen}">
    <div class="notice-center-container" v-loading="noticeLoading || saveLoading">
      <div class="left-list-container">
        <p class="left-list-header">消息中心</p>
        <div class="left-list-content">
          <ul class="tab-box">
            <li class="tab-item" :class="{'is-active': currentTab === 0}" @click="onTab(0)">未读</li>
            <li class="tab-item" :class="{'is-active': currentTab === 1}" @click="onTab(1)">历史消息</li>
          </ul>
          <el-input class="search-input" prefix-icon="el-icon-search" type="text" v-model="searchValue"  placeholder="搜索" @keyup.enter="onSearch"
        @change="onSearch">
        </el-input>
          <div class="list-box">
            <NoticeList v-if="!noticeLoading && noticeList?.length" :messageList="noticeList" :loading="loading" @on-notice="onNotice" @scroll="handleScroll" />
            <div v-else class="empty-box">
              <el-empty size="small" :description="currentTab === 0 ? '暂无未读消息' : '暂未收到通知'"></el-empty>
            </div>
          </div>
        </div>
        <div class="left-list-bottom">
          <div class="readed-box" @click="onAllRead">
            <el-badge is-dot :hidden="noReadData?.length > 0 ? false : true" class="badge">
              <i class="iconfont iconquanbuyidu notice-icon"></i>
            </el-badge>
            <span>全部已读</span>
          </div>
        </div>
      </div>
      <div class="right-content-container">
        <div class="right-header">
          <p>详情</p>
          <div class="btn-group">
            <div class="btn-box">
              <i class="iconfont  close-icon" :class="!isFullScreen ? 'iconquanping6' : 'icontuichuquanping1'" @click="onFullScreen"></i>
            </div>
            <div class="btn-box">
              <i class="iconfont iconbimgis_guanbi close-icon" @click="handleClose"></i>
            </div>
          </div>
        </div>
        <div class="content-list">
          <div class="list-box" v-if="noticeInfo?.id">
            <div class="list-item-box">
              <MessageCard :noticeInfo="noticeInfo" @jump="onJump" @download="onDownload" />
            </div>
          </div>
          <div class="empty-box">
            <el-empty description="请选择左侧通知"></el-empty>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import {Dialog,Empty,Badge,Input,Scrollbar} from "element-ui";
import NoticeList from './NoticeList.vue';
import MessageCard from './MessageCard.vue';
import {dataInterface} from "@/apis/data";
import { downloadFileBlob } from '@/utils/tools';
import { getNotRead } from '../api/index';

export default {
  components: {
    "el-badge": Badge,
    "el-empty": Empty,
    "el-dialog": Dialog,
    "el-input": Input,
    NoticeList,
    MessageCard
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    messageInfo:{
      type: Object,
      default: ()=>{
        return {};
      }
    }
  },
  data() {
    return {
      userInfo:{},
      noticeList:[],
      noticeInfo:{},
      isFullScreen:false,
      searchValue:'',
      currentTab:0,
      size:15,
      page:1,
      total:0,
      loading:false,
      noMoreData:false,
      noticeLoading:true,
      noReadData:[],
      showFlag: false,
      saveLoading: false
    };
  },
  computed: {
  },
  watch: {
    show: {
      handler(val){
        this.showFlag = val;
      },
      deep:true,
      immediate: true
    }
  },
  methods:{
    getNoticeList(isReset = true){
      this.loading = true;
      const params = {
        object_uuid: 'object6735a9889cc38',
        __method_name__: 'dataList',
        view_uuid: 'view6736c498a1746',
        transcode: 0,
        size: this.size,
        page: this.page,
      };
      if(+this.currentTab == 0){
        params.view_uuid = 'view683e6c7d5d62a';
      }
      if(this.searchValue){
        params.search = [{
          code: 'title',
          ruleType: 'like',
          value: this.searchValue
        }];
      }
      dataInterface(params).then((res) => {
        if(res.data.code === 200){
          const newData = res?.data?.data?.data || [];
          this.total = res?.data?.data?.total;
          if (newData.length === 0) {
            if(isReset){
              this.noticeList = newData;
            }else{
              this.noMoreData = true;
              this.page = this.page - 1;
            }
            this.loading = false;
            this.noticeLoading = false;
            return;
          }
          if(isReset){
            this.noticeList = newData;
          }else{
            this.noticeList = [...this.noticeList, ...newData];
          }
        }
        this.$nextTick(() => {
          this.loading = false;
        });
        this.noticeLoading = false;
      });
    },
    

    onSearch(){
      this.page  = 1;
      this.getNoticeList(true);
    },

    handleScroll(){
      if (this.page * this.size < this.total) {
        this.page++;
        this.getNoticeList(false);
      }
    },

    onFullScreen(){
      this.isFullScreen = !this.isFullScreen;
    },


    async getAllNotRead(){
      this.noReadData = await getNotRead(this.userInfo);
    },


    onNotice(data){
      if(data?.is_read === 0){
        // 去已读
        this.checkRead(data);
      }
      this.noticeInfo = data;
    },

    onTab(val){
      this.page = 1;
      this.noticeList = [];
      this.currentTab = val;
      this.getNoticeList();
    },

    handleClose(){
      this.$emit('close')
      this.$emit('refresh')
    },

    onAllRead(){
      this.saveLoading = true;
      dataInterface({user_id: this.userInfo.id},'api/notify/batchUpdateUserIsRead','POST').then(res=>{
        this.saveLoading = false;
        if(res.data.code === 200){
          this.noReadData = [];
          this.getNoticeList();
          this.$emit('refresh');
        }
      });
    },

    checkRead(data){
      const params = {
        object_uuid: 'object6735a9889cc38', 
        __method_name__: 'updateData',
        view_uuid: 'view6736c498a1746',
        transcode: 0,
        data_id: data.id,
        is_read: 1,
      };
      dataInterface(params).then((res) => {
        if(res.data.code === 200){
          data.is_read = 1;
          this.getAllNotRead();
        }
      });
    },

    onJump (data){
      this.handleClose();
      if(data?.extra?.page_uuid){
        window.open(window.origin + '/page-editor?page_uuid=' + data?.extra?.page_uuid);
      }
    },

   async onDownload(data){
      if(data?.extra?.download_url){
        await downloadFileBlob(data?.extra?.download_url, data?.extra?.zip_name ? `${data?.extra?.zip_name}.zip` : '未命名文件.zip');
        this.$message.success('下载成功');
      }
    }
  },
  mounted() {},
  created() {
    this.dataInfo = this.noticeInfo;
    this.getNoticeList();
    this.getAllNotRead();
  },
}
</script>
<style lang="less">
.custom-notice-message-center-dialog{
  .el-dialog__header{
    display: none;
  }
  .el-dialog__body{
    padding: 0;
    height: 74vh;
  }
  .el-dialog{
    border-radius: 12px;
    overflow: hidden;
  }
  &.custom-notice-message-center-fullscreen{
    .el-dialog__body{
      height: 100%;
    }
  }
}
</style>
<style lang="less" scoped>
.notice-center-container{
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
  .empty-box {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .left-list-container{
    width: 320px;
    height: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 16px 0px 0px 0px;
    background: var(--overall-surface-default, #FFF);
    overflow: hidden;
    flex-shrink: 0;
    .left-list-header{
      width: 100%;
      height: 64px;
      padding: 0px 20px 0px 24px;
      box-sizing: border-box;
      color: var(--text-on-surface-primary, #181B22);
      font-family: "PingFang SC";
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: 0.5px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
    }
    .left-list-content{
      flex: 1;
      width: 100%;
      padding: 0 16px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      gap: 12px;
      box-sizing: border-box;
      overflow: hidden;
      .tab-box{
        width: 100%;
        height: 36px;
        border-radius: var(--Radio-8, 8px);
        background: var(--overall-surface-variant, #F2F5FA);
        display: flex;
        padding: 3px;
        box-sizing: border-box;
        align-items: center; 
        gap: 3px;
        flex-shrink: 0;
        .tab-item{
          flex: 1;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--text-on-surface-tertiary, #707786);
          font-family: "PingFang SC";
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px;
          letter-spacing: 0.5px;
          cursor: pointer;
          &.is-active{
            border-radius: var(--Radio-6, 6px);
            background: var(--overall-surface-default, #FFF);
            box-shadow: 0px 1px 3px 0px rgba(25, 27, 35, 0.04), 0px 0px 0px 0px rgba(255, 255, 255, 0.01) inset, 0px 2px 16px 0px rgba(25, 27, 35, 0.08);
            color: var(--text-on-surface-link-default, #387FFC);
          }
        }
      }
      :deep(.search-input){
        flex-shrink: 0;
        padding-top: 4px;
        box-sizing: border-box;
        .el-input__prefix{
          top: 2px;
        }
      }
      .list-box{
        width: 100%;
        flex: 1;
        overflow: hidden;
      }
    }
    .left-list-bottom{
      height: 48px;
      padding: 0px 28px;
      border-top: 1px solid var(--border-on-surface-weak, #F0F1F4);
      flex-shrink: 0;
      .readed-box{
        height: 100%;
        width: fit-content;
        display: flex;
        box-sizing: border-box;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        :deep(.el-badge){
          .el-badge__content{
            width: 6px;
            height: 6px;
            top: 2px;
            right: 8px;
            background: var(--semantic-error-on-background, #FC5558);
          }
        }
        span{
          color: var(--text-on-surface-placeholder, #A4ACBD);
          font-family: "MiSans VF";
          font-size: 13px;
          font-style: normal;
          font-weight: 330;
          line-height: 20px;
        }
        i{
          font-size: 20px;
          display: block;
          color: var(--text-on-surface-placeholder, #A4ACBD);
        }
      }
    }
  }
  .right-content-container{
    flex: 1;
    height: 100%;
    background: var(--overall-surface-variant, #F2F5FA);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .right-header{
      width: 100%;
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 16px 0 32px;
      box-sizing: border-box;
      flex-shrink: 0;
      .title{
        color: var(--text-on-surface-secondary, #424751);
        font-family: "PingFang SC";
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        letter-spacing: 0.5px;
      }
      .btn-group{
        display: flex;
        align-items: center;
        gap: 12px;
        .btn-box {
          width: 24px;
          height: 24px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          &:hover {
            background: var(--overall-surface-default-hover, #F4F6F9);
          }
          &:active {
            background: var(--brand-gray-90, #E1E4EC);
          }
          i {
            font-size: 20px;
            display: block;
            color: var(--icon-on-surface-secondary,#4D535E);
          }
        }
      }
    }
    .content-list{
      width: 100%;
      flex: 1;
      overflow: hidden;
      padding: 0 28px 16px 28px;
      box-sizing: border-box;
      .list-box{
        width: 100%;
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;
      }
      .list-item-box{
        width: 100%;
        min-height: 170px;
        border-radius: 10px;
        background: var(--overall-surface-default, #FFF);
        margin-bottom: 16px;
        &:last-child{
          margin: 0;
        }
      }
    }
  }
} 

</style>
